import ComingWithImageBgContainer from "../../Componant/ComingSoon/ComingWithImageBg";

const ComingWithImageBg = () => {
  return (
    <div className="page-wrapper compact-wrapper">
      <ComingWithImageBgContainer />
    </div>
  );
};

export default ComingWithImageBg;
